module.exports = __webpack_public_path__ + "static/media/16.69174f97.JPG";